import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsPlinkoService, placeBetPlinkoGameService, postLightningBoardDetailsService } from '../services/pyramidPlinkoGame.service'
import { fastModeBox, pixiCancelBall, pixiSetAutoBet, pixiStartMovingBall, setPayoutValue } from '../GameTheme/PyramidPlinkoGame/pixi-js-scripts/bridge'
import { enqueueCreditWalletWaitQueue, debitBalance, dequeueCreditWalletWaitQueue } from 'redux-store/redux/slices/auth.slice'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { appendMyBetsPlinko, setBetLock } from './pyramidPlinkoGame.slice'
import { divide } from 'number-precision'
import { CURRENCIES } from 'utils/constants/index'
import { generateClientSeed, getNumToStringPrecision } from 'utils/common-functions/index'

export const placedBetPlinkoGame = createAsyncThunk('plinko-game/place-bet',
  async ({ payload, id, fastMode, autoBet = false }, thunkApi) => {
    try {
      const newClientSeed = generateClientSeed()
      thunkApi.dispatch(setNewClientSeed(newClientSeed))
      // Deducting the balance from the main balance after the bet is placed successfully
      const res = await placeBetPlinkoGameService(payload)
      thunkApi.dispatch(debitBalance(res?.betAmount))
      thunkApi.dispatch(enqueueCreditWalletWaitQueue(res?.winningAmount))
      if (res?.nextServerSeedHash) {
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }
      if (fastMode) {
        fastModeBox(res.dropDetails)
        thunkApi.dispatch(setBetLock())
        thunkApi.dispatch(appendMyBetsPlinko())
      } else {
        const lastBall = res?.dropDetails.length
        pixiSetAutoBet(autoBet)
        pixiStartMovingBall(res.dropDetails, lastBall, res?.winningAmount)
        const winningAmount = `${CURRENCIES[res?.currencyCode]?.symbol} ${getNumToStringPrecision(Number(res?.winningAmount))}`
        const multiplier = `${res?.coefficient}x`
        setPayoutValue(winningAmount, multiplier)
      }
      return res
    } catch (error) {
      if (!fastMode) {
        pixiCancelBall()
      }
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBetsPlinko = createAsyncThunk('plinko-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsPlinkoService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const postLightningBoardDetails = createAsyncThunk('plinko-game/post-lightning-board-details', async (params, thunkApi) => {
  try {
    const res = await postLightningBoardDetailsService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description)
  }
})
